export default __webpack_public_path__ + "static/media/est-ensemble_picture.dbe800f0.jpg";